import { Vector2, Vector3 } from 'three';
import { MPUtils } from './MPUtils';

export class J3MatterportSDK extends EventTarget {
    // J3ThreeSubからコールされるメソッド
    mpSdk;
    mpUtils: MPUtils;
    pose;
    floorSeq:number;
    sweepID: string = null;
    position: Vector3 = new Vector3();
    rotation: Vector2 = new Vector2();

    constructor(public debugLvl = 0, containerID: string, key: string, spaceID: string, queryParam: string, startParam: string, pBillboards) {
        super();
        //const container = document.querySelector('.matterport-showcase')
        const container: HTMLElement = document.querySelector('#' + containerID) as HTMLElement;
        if (container) {
            this.Initialize(container, key, spaceID, queryParam, startParam, pBillboards);
        } else {
            console.log('Matterport Container', containerID, 'not found');
        }
    }

    Initialize(container: HTMLElement, key: string, spaceID: string, queryParam: string, startParam: string, pBillboards) {
        const showcase = document.createElement('iframe');     //contentWindowを使うため、HTMLIFrameElementにキャストしてもよい
        //const showcaseWindow = showcase.contentWindow;
        //showcase.setAttribute("src", "bundle/showcase.html?m=PQiKCGd1rhu&applicationKey=knby2fi56zncgf41q6yir73tb&play=1&qs=0&title=0&brand=0&sr=-3.02%2C-.98&ss=31");
        const srcParam = 'bundle/showcase.html?m=' + spaceID + '&applicationKey=' + key + '&' + queryParam + '&' + startParam;
        showcase.setAttribute("src", srcParam); //srcParamはMatterport Showcaseのクエリパラメータを設定済
        showcase.setAttribute("width", "100%");
        showcase.setAttribute("height", "100%");
        showcase.setAttribute("frameBorder", "0");
        //showcase.setAttribute("allow", "xr-spatial-tracking"); //VR用の設定
        showcase.setAttribute("wmode", "Opaque");   //iframe内のz-indexを有効にするため
        showcase.setAttribute("allow", "fullscreen");
        showcase.setAttribute("id", "showcase");
        container.appendChild(showcase);

        let mpSdk;
        const _self = this; //コールバック内でクラスメソッドを呼び出すためにthisを変数_selfに代入しておく
        showcase.addEventListener('load', async function () {

            //const main = new Main(deploy, debugLvl, _site, _space, _title, _sound);  //メインクラス
            //if (this.debugLvl > 0) console.log('main.debugLvlForMove %s', main.debugLvlForMove);
            try {
                //mpSdk = await showcase.contentWindow.MP_SDK.connect(showcase, key, sdkVersion);
                mpSdk = await showcase.contentWindow.MP_SDK.connect(showcase, key, '');
                //SDK接続後の処置
                console.log('mpSdk', mpSdk);
                const overlay = document.getElementById('overlay') as HTMLElement;
                if (overlay) {
                    overlay.style.display = 'block';
                    //overlay.style.visibility = 'invisible'; //開始時はオーバーレイを非表示にする
                    overlay.style.visibility = 'visible'; //開始時はオーバーレイを表示にする
                }
                //メインルーチンへ
                //const main = new Main(mpSdk, deploy, debugLvl, spaceid, loc);
                //main.Main(mpSdk); //MainクラスのMain(mpSDK)メソッドをコール
                _self.mpSdk = mpSdk;
                _self.mpUtils = new MPUtils(mpSdk);
                _self.PoseMonitor(mpSdk, _self);    //座標のモニタリング。_selfも渡す
                _self.FloorMonitor(mpSdk, _self);   //フロアのモニタリング
                //_self.DummyMethod();
                _self.SetTagImage(pBillboards);
            }
            catch (e) {
                console.error(e);
                return;
            }
        });

    }

    DummyMethod() {
        console.log('J3MatterportSDK');
        console.log(this.mpSdk);
        // ============================================
        // 全タグの出力
        //let outstr = '';
        if (this.debugLvl > 0) this.mpSdk.Mattertag.getData()
            .then(function (mattertags) {
                if (mattertags.length > 0) {
                    mattertags.forEach(value => console.log("{ sid: \"" + value.sid + "\"\, label: \"" + value.label + "\" },"));
                }
            })
            .catch(function (error) {
                console.log("Can't get MP tags");
                console.log(error);
            })
    }

    SetTagImage(pBillboards){
        console.log('**********', this.debugLvl, pBillboards.enable);
        if (!pBillboards.enable || !pBillboards.iconData || !pBillboards.iconName) return;
        console.log('SetTagImage:iconData', pBillboards.iconData);
        //const icons = this.mpUtils.RegisterIcons(pBillboards.iconData);   //アイコンデータの登録
        const icons = this.mpUtils.RegisterIconsNew(pBillboards.iconData, pBillboards.index);   //アイコンデータの登録 Mattertag 2.0
        console.log('SetTagImage:icons',icons);
        console.log('********')

        /*
        const enableTag20 = true;    // ***** Mattertag2.0のAPI不明のため、現状以下は実行していない *****
        var mpUtils = this.mpUtils; //次のfunciton()内からthis.mpUtilsにアクセスできないためローカル変数に代入
        this.mpSdk.Mattertag.getData()
            .then(function (mattertags) {
                if (mattertags.length > 0) {
                    mattertags.forEach(value => {
                        const tagsid = value.sid;
                        console.log("{ sid: \"" + tagsid + "\"\, label: \"" + value.label + "\" },")
                        if(enableTag20) mpUtils.SetTagImageOfNew(value.sid, icons[pBillboards.index]);  //Mattertag 2.0
                 });
                }
            })
            .catch(function (error) {
                console.log("******** Can't set tags");
                console.log(error);
            })
        */
    }

    Mapping(pose) {
        this.sweepID = pose.sweep;
        const px = pose.position.x;
        const py = pose.position.y;
        const pz = pose.position.z;
        const rx = pose.rotation.x;
        const ry = pose.rotation.y;
        this.position = new Vector3(px, py, pz);
        this.rotation = new Vector2(rx, ry);

        const d = 3;
        if (this.debugLvl > 1) {
            console.log('{name:\'xxxxxx\', sweepId:\' ', this.sweepID, '\', position:{ x: ', px.toFixed(d), ', y:', py.toFixed(d), 'z:', pz.toFixed(d),
                '\', rotation:{ x: ', rx.toFixed(d), ', y:', ry.toFixed(d), ' }},');
        }
    }
    //小数点以下桁数を揃えた文字列へ変換
    Fix3(value: number) {
        return this.Fix(value, 3);
    }
    Fix2(value: number) {
        return this.Fix(value, 2);
    }
    Fix(value: number, digits: number = 1) {
        return value.toFixed(digits);
    }

    PoseMonitor(mpSdk, _self) {
        //カメラ位置の取得（サブスクリプション）
        console.log('Subscribe to pose');
        mpSdk.Camera.pose.subscribe(function (pose) {
            _self.pose = pose;
            _self.Mapping(pose);
        })
    }

    FloorMonitor(mpSdk, _self) {
        console.log('Subscribe to floor');
        mpSdk.Floor.current.subscribe(function (currentFloor) {
            //フロアの変更を知らせる
            if(_self.floorSeq != currentFloor.sequence){
                _self.floorSeq = currentFloor.sequence;
                const event = new CustomEvent("FloorChanged", { detail: { id:currentFloor.id, sequence: currentFloor.sequence, name:currentFloor.name} });
                _self.dispatchEvent(event);
                //console.log('FloorChanged', _self.floorSeq);
            }
            
            if (currentFloor.sequence === -1) {
                console.log('Currently viewing all floors');
            } else if (currentFloor.sequence === undefined) {
                if (currentFloor.id === undefined) {
                    console.log('Current viewing an unplaced unaligned sweep');
                } else {
                    console.log('Currently transitioning between floors');
                }
            } else {
                console.log('Currently on floor', currentFloor.id, currentFloor.sequence, 'name', currentFloor.name);
                //console.log('Current floor\'s sequence index', );
                //console.log('Current floor\'s name', currentFloor.name)
            }
        });
    }
}